import React from 'react'
import Box from '@mui/material/Box'

const CustomCard = (props) => {
  const { sx, marginRight } = props

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'hidden', 
        position: 'relative',
        ...sx,
      }}
    >
      <Box
        sx={{
          m: 1,
          height: '90%', 
          position: 'absolute', 
          top: 0, 
          bottom: 0, 
          left: 0, 
          right: marginRight ? marginRight : -19, 
          overflowY: 'scroll',
          overflowX: 'hidden',
          ...sx
        }}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default CustomCard